import { readPdfTemplatesApiOriginEnv } from './pdfTemplatesApiOriginEnv';

export const resolvePdfTemplatesOrigin = (): string => readPdfTemplatesApiOriginEnv();
